module.exports = "<svg viewBox=\"0 0 24 19\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.782 16.21L2.24 9.79c-.318-.312-.32-.82-.005-1.134.315-.315.83-.316 1.148-.005l5.928 5.817 10.733-12.19c.293-.335.806-.37 1.144-.08.338.292.373.798.08 1.133L9.964 16.166c-.147.168-.358.267-.582.275-.243.002-.45-.082-.6-.23z\" stroke=\"#FFF\" stroke-width=\"4\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./node_modules/shared-web/src/components/CheckBox/check.svg
// module id = CMne
// module chunks = 88